import React from "react";
import Card from "./Card";
import StatusCard from "./StatusCard";
import "./ReferLinkCard.css";
import "./StatusGrid.css";

const StatusGrid = ({ items }) => {
  return (
    <Card>
      <div className="linkhead1">
        <h4>Referral Status</h4>
        <hr />
      </div>
      
      <div className="card-grid1" style={{ display: "flex", gap: "10px", width: "100%" }}>
        {items.map((item, index) => (
          <StatusCard 
            key={index} 
            {...item}
            onClick={item.onClick} // Pass onClick from item prop
          />
        ))}
      </div>
    </Card>
  );
};

export default StatusGrid;